import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { MechanicService } from '../../../business-services/mechanic.service';
import { MechanicReportResponseModel } from '../../../business-entities/mechanic-report-model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
@Component({
  selector: 'app-mechanic-report',
  templateUrl: './mechanic-report.component.html',
  styleUrls: ['./mechanic-report.component.css']
})
export class MechanicReportComponent implements OnInit {
  dealerId: string;
  isDealerRequired: boolean;
  dealerList: DealerViewModel[] = [];
  fromDate: string;
  toDate: string;
  showData: boolean = false;
  mechanicReport: Array<MechanicReportResponseModel> = [];

  ;
  constructor(
    private dealerBusinessService: DealerBusinessService,
    private mechanicService: MechanicService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private userService: UserDataService,
    private excelService: ExcelService,
  ) { }

  ngOnInit(): void {
    this.dealerId = this.userService.currentUserValue.defaultDealerId;
    // Set Current Date in From Date and To Date
    this.fromDate = Utility.GetFormattedDate(new Date());
    this.toDate = Utility.GetFormattedDate(new Date());
    this.getUserDealers();
    this.onSearchReport();
  }
  async getUserDealers() {
    this.spinner.show();
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapDealer(response.userDealersModel);
      this.spinner.hide();
    });
  }
  onDealerSelected(dealerId: string) {
    this.resetData();
    if (dealerId) {
      this.isDealerRequired = false;
      this.dealerId = dealerId;
    }
    else {
      this.isDealerRequired = true;
      this.dealerId = null;
    }
  }

  resetData() {
    this.showData = false;
    this.mechanicReport = [];
  }



  mapDealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach((element)=>{
        let single = Object();
        single.value = element.dealerId;
        single.text = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onSearchReport() {
    if (!isNullOrUndefined(this.dealerId)) {
      this.loadReport();
    }
    else
    {
      this.isDealerRequired = true;
    }
  }

  async loadReport() {
    this.spinner.show();
    this.mechanicService.GetMechanicReport(this.dealerId).then(response => {
      if (response && response.responseCode == Constant.SuccessResponseCode) {
        this.mechanicReport = response.responseObject;
        if (!isNullOrUndefined(this.mechanicReport)) {
          this.showData = true;
        }
      }
      else
        this.toastr.error(this.translate.instant('lblDataNotAvailable'));
      this.spinner.hide();
    });
    this.spinner.hide();
  }
  // Export functionality

  public async exportAsXLSX(): Promise<void> {
    if (await this.validateExport()) {
      const excelData = this.mapExportData();
      this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblMechanicReport')}`);
    }
  }

  public async exportAsPDF(): Promise<void> {
    if (await this.validateExport()) {
      const pdfData = this.mapExportData();
      const doc = new jsPDF('portrait');
      autoTable(doc, {
        head: [this.getExportHeaders()],
        body: pdfData.map(row => Object.values(row)),
        margin: { top: 3, left: 3, right: 3, bottom: 3 },
        styles: { fontSize: 8 },
        columnStyles: {
          0: { cellWidth: 12 },
          1: { cellWidth: 34 },
          2: { cellWidth: 34 },
          3: { cellWidth: 30 },
          4: { cellWidth: 48 },
          5: { cellWidth: 50 }
        }
      });
      doc.save(`${this.translate.instant('lblMechanicReport')}.pdf`);
    }
  }

  private async validateExport(): Promise<boolean> {
    if (!this.dealerId) {
      this.isDealerRequired = true;
      return false;
    }

    if (this.mechanicReport.length === 0) {
      await this.loadReport();
    }

    if (this.mechanicReport.length === 0) {
      this.toastr.error(this.translate.instant('lblDataNotAvailable'));
      return false;
    }
    return true;
  }

  private mapExportData(): any[] {
    return this.mechanicReport.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblMechanicName')]: item.name,
      [this.translate.instant('lblEmployeeNumber')]: item.employeeNo,
      [this.translate.instant('lblEfficiency')]: item.efficiency,
      [this.translate.instant('lblSkillSet')]: item.skillDescription,
      [this.translate.instant('lblCompetence')]: item.competenceName
    }));
  }

  private getExportHeaders(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblMechanicName'),
      this.translate.instant('lblEmployeeNumber'),
      this.translate.instant('lblEfficiency'),
      this.translate.instant('lblSkillSet'),
      this.translate.instant('lblCompetence')
    ];
  }
}